import React from 'react';
/**
 * data Columns for grid and mobile view
 * @type {React.FC<Props>}
 * @returns {React.ReactElement} The Data Columns Array
 */
export const DataColumns = ({
  editScreen,
  MultiViewCalenderFilterCell,
  dateRangeFilter,
  GridDateCell,
  setDateRangeFilter,
  GridFlag,
  BooleanFlagFilterCell,
  isActive,
}) => {
  const dataColumns = [
    {
      field: 'organization_id',
      title: 'organization_id',
      editable: false,
      show: false,
      width: '250px',
      width: '250px',
      minResizableWidth: 150,
      filterable: true,
      excludeFromFilter: true,
    },
    {
      field: 'name',
      title: 'Name',
      editable: false,
      show: true,
      width: '250px',
      minResizableWidth: 50,
      cell: (props) => (
        <>
          {isActive ? (
            <td
              className='edit-link'
              onClick={() => {
                editScreen(props.dataItem);
              }}
            >
              {props.dataItem.name}
            </td>
          ) : (
            <td>{props.dataItem.name}</td>
          )}
        </>
      ),
    },
    {
      field: 'obj_prefix',
      title: 'Prefix',
      editable: false,
      show: true,
      width: '250px',
      minResizableWidth: 150,
      filterable: true,
      excludeFromFilter: true,
    },
    {
      field: 'email_domain',
      title: 'Email Domain',
      editable: false,
      show: true,
      width: '250px',
      minResizableWidth: 150,
      filterable: true,
      excludeFromFilter: true,
    },
    {
      field: 'active',
      title: 'Active',
      editable: false,
      show: isActive,
      width: '120px',
      minResizableWidth: 50,
      cell: GridFlag,
      filterCell: BooleanFlagFilterCell,
    },
    {
      field: 'description',
      title: 'Description',
      editable: false,
      show: true,
      width: '250px',
      minResizableWidth: 150,
      filterable: true,
      excludeFromFilter: true,
    },
    {
      field: 'created_by',
      title: 'Created By',
      editable: false,
      show: true,
      width: '200px',
      minResizableWidth: 50,
    },
    {
      field: 'created_date',
      title: 'Created Date',
      editable: false,
      show: true,
      width: '300px',
      minResizableWidth: 50,
      filter: 'date',
      type: 'dateRange',
      filterCell: (props) =>
        MultiViewCalenderFilterCell({
          ...props,
          dateRangefilter: dateRangeFilter,
          setDateRangeFilter,
          field: 'created_date',
        }),
      isRequired: true,
      cell: GridDateCell,
    },
    {
      field: 'modified_by',
      title: 'Modified By',
      editable: false,
      show: true,
      width: '200px',
      minResizableWidth: 50,
    },
    {
      field: 'modified_date',
      title: 'Modified Date',
      editable: false,
      show: true,
      width: '300px',
      minResizableWidth: 50,
      filter: 'date',
      type: 'dateRange',
      filterCell: (props) =>
        MultiViewCalenderFilterCell({
          ...props,
          dateRangefilter: dateRangeFilter,
          setDateRangeFilter,
          field: 'modified_date',
        }),
      isRequired: true,
      cell: GridDateCell,
    },
  ];

  return dataColumns;
};
export default DataColumns;
